import { Store } from 'redux'
import { Entity } from '../app/entity'
import { ApplicationState } from '../redux/ApplicationState'
import { DashboardState } from '../redux/dashboard/DashboardState'

/**
 * Loader classes like this consilidate all loading profileLists for a domain
 * concept.
 *
 * They define one (or multiple) load() methods which execute an AJAX call
 * through the Api. You may implement parameter remapping and cache checks in
 * here. For the loaded date there should be a dispatched action through Redux.
 *
 * The Loader also defines a (static) method which handles its own actions and
 * applies the corresponding changes to the global store state.
 */
const Loader = function(store: Store<ApplicationState>, api) {
    this.store = store
    this.api = api

    this.load = parameters => {
        this.api.triggerContinuously('XhprofOrganizationBundle.Organization.dashboardData', parameters)
    }
}

const initialGlobalState: DashboardState = {
    dashboard: null,
}

Loader.handleAction = (globalState: DashboardState = initialGlobalState, action): DashboardState => {
    switch (action.type) {
        case 'TIDEWAYS_ROUTE':
            return {
                dashboard: Entity.purge(globalState.dashboard ?? new Entity()),
            }
        case 'Organization.dashboardData.success':
            return {
                ...globalState,
                dashboard: new Entity(action.data, 0),
            }
        case 'Organization.dashboardData.error':
            return {
                ...globalState,
                dashboard: new Entity().setError(action.error),
            }
    }

    return globalState
}

export default Loader
